export default "__VITE_ASSET__6fee0096__$_?nuxt_component=async__"